import React from "react";
import styles from "../../Styles/Modules/Modal.module.scss";
import Button from "../Button/Button";
import { IoClose } from "react-icons/io5";
import { closeModal } from "../../State/Slices/modalSlice";
import { useTranslation } from "react-i18next";

const Modal = ({ modifier, name, active, title, children }) => {
  const { t } = useTranslation();

  return (
    <div
      className={`${styles.modal} ${styles[modifier]} ${
        name === active ? styles.modalActive : ""
      }`}
    >
      {!["session", "intro"].includes(name) && (
        <Button
          action={() => closeModal()}
          title="close"
          modifier="buttonClose"
          icon={IoClose}
        />
      )}

      <div className={styles.modalHeader}>{title && t(`${title}`)}</div>

      <div className={styles.modalContent}>{children}</div>
    </div>
  );
};
export default Modal;
